import { makeStyles } from '@material-ui/core/styles';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
// import NumberFieldPreview from '@sprinx/react-mui-fields/NumberFieldPreview';
import TextFieldPreview from '@sprinx/react-mui-fields/TextFieldPreview';
import clsx from 'clsx';
import React from 'react';
import NumberFieldPreview from '@sprinx/react-mui-fields/NumberFieldPreview';
import { CatalogueProduct } from '../../../api/products/catalogue';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface CataloguePageListContentItemRowInlineParametersProps
  extends StandardDivProps<CataloguePageListContentItemRowInlineParametersClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemRowInlineParametersClassKey = 'root' | 'field';

const themeSettings = { name: 'CataloguePageListContentItemRowInlineParameters' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      '@media(min-width: 1280px) and (max-width: 1440px)': {
        maxWidth: '325px',
      },
      '@media(min-width: 960px) and (max-width: 1155px)': {
        maxWidth: '284px',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none !important',
      },
    },
    field: {
      [theme.breakpoints.down('sm')]: {
        width: '33%',
      },
    },
    // expirationDateField: {
    //   [theme.breakpoints.down('sm')]: {
    //     width: '50%',
    //   },
    //   width: 'max-content',
    // },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowInlineParameters = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemRowInlineParametersProps
>(({ className, classes: pClasses, product, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  // const expirationDate = product && product.extra ? (product.extra as any).expirationDate : undefined;
  const t = useTranslateWithFallback();

  return (
    <GridAreaContainer ref={ref} className={clsx(classes.root, className)} renderToGridArea='parameters' {...rest}>
      <TextFieldPreview label={t('common/code')} value={product.sku || ''} size='small' className={classes.field} />
      <NumberFieldPreview
        label={t('productPage/minOrderableQuantity')}
        value={product.quantityStep}
        size='small'
        decimalPrecision={0}
        className={classes.field}
      />
      <TextFieldPreview label={t('common/unit')} value={product.unit} size='small' className={classes.field} />
    </GridAreaContainer>
  );
});

CataloguePageListContentItemRowInlineParameters.displayName = 'CataloguePageListContentItemRowInlineParameters';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowInlineParameters);
